import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

export const ColorPickerField = ({ label, value, onChange, testId }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <div className="flex items-center gap-2 mt-1">
      <div className="relative">
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="w-10 h-10 rounded-sm cursor-pointer border border-border"
          style={{ padding: 0 }}
          data-testid={testId}
        />
      </div>
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="#000000"
        className="bg-secondary border-border font-mono text-xs h-10 w-24"
      />
    </div>
  </div>
);
